import { EnrollmentInvestmentObjectiveCategory } from '@egw/api'

export interface InvestmentOptionGoal {
  value: EnrollmentInvestmentObjectiveCategory
  label: string
}

/**
 * Sorts investment option goals in a logical order for display
 * Priority order: Generate Income, Specific Goal, Save for Retirement, Build Wealth, Cash Management
 */
export const sortInvestmentOptionGoals = (options: InvestmentOptionGoal[]): InvestmentOptionGoal[] => {
  const priorityOrder = [
    EnrollmentInvestmentObjectiveCategory.GENERATE_INCOME,
    EnrollmentInvestmentObjectiveCategory.SPECIFIC_GOAL,
    EnrollmentInvestmentObjectiveCategory.SAVE_FOR_RETIREMENT,
    EnrollmentInvestmentObjectiveCategory.BUILD_WEALTH,
    EnrollmentInvestmentObjectiveCategory.CASH_MANAGEMENT,
  ]

  return [...options].sort((a, b) => {
    const aIndex = priorityOrder.indexOf(a.value)
    const bIndex = priorityOrder.indexOf(b.value)

    // If both values are in the priority order, sort by their position
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex
    }

    // If only one is in the priority order, prioritize it
    if (aIndex !== -1) return -1
    if (bIndex !== -1) return 1

    // If neither is in the priority order, maintain original order
    return 0
  })
}
